import { TGroupedNotifications, TNotificationsResponse } from '../../types'

export const productMatchAdapter =
  (groupedNotifications: TGroupedNotifications, notification: TNotificationsResponse): TGroupedNotifications => ({
    ...groupedNotifications,
    ...(notification.notification_type && notification.id && {
      [notification.notification_type]: {
        ...groupedNotifications[notification.notification_type],
        // no need to group and count
        [notification.id]: {
          ...notification,
          count: 1,
          ids: [{ id: notification.id, notification_type: notification.notification_type }],
          last_updated: new Date(notification.product?.publish_date ?? '').getTime(),
          card: {
            title: 'Product Match',
            subtitle: `${notification.product?.campaign?.artist?.name ?? ''}, ${notification.product?.name ?? ''}`,
            icon: 'music',
            highlighted: true,
            count: '1 Product'
          }
        }
      }
    })
  })